const MSG_PREFIX = 'naighlojeckmcdjnoiaelgmijbaplobm/'; // ext id

function createMessage(data) {
  return `${MSG_PREFIX}${data.message}`;
}

function getMessage(data) {
  return data?.message?.replace(MSG_PREFIX, '') || '';
}

function promisify(cb) {
  return (...data) =>
    new Promise((resolve, reject) => {
      cb(...data, resolve, reject);
    });
}

export function onMessage(message, cb) {
  function messageProxy(event) {
    if (event.origin !== window.location.origin) {
      return;
    }

    if (!event.data.message) {
      return;
    }

    const resMessage = getMessage(event.data);

    if (event.data.message === resMessage) {
      return;
    }

    if (resMessage === message) {
      cb({
        ...event.data,
        message,
      });
    }
  }

  window.addEventListener('message', messageProxy, false);
  return () => window.removeEventListener('message', messageProxy, false);
}

export function sendMessage(data, cb, cberr) {
  window.postMessage(
    {
      ...data,
      message: createMessage(data),
      answer: !!cb,
    },
    window.location.origin,
  );

  if (!cb) {
    return;
  }

  const reqMessage = data.message;
  const message = `${reqMessage}/response`;
  const timeoutId = setTimeout(() => {
    // eslint-disable-next-line no-use-before-define
    flushAll();
    cberr(`Response timeout for event: ${reqMessage}`);
  }, 3000);

  const releaseRespListener = onMessage(message, (resData) => {
    // eslint-disable-next-line no-use-before-define
    flushAll();
    if (resData.error) {
      cberr(resData.error);
    } else {
      cb(resData.data);
    }
  });

  function flushAll() {
    clearTimeout(timeoutId);
    releaseRespListener();
  }
}

sendMessage.async = function sendMessageAsync(data) {
  return promisify(this)(data);
};
